// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export * from './cardExtV1Api';
import { CardExtV1Api } from './cardExtV1Api';
export * from './caseV3Api';
import { CaseV3Api } from './caseV3Api';
export * from './claimV1Api';
import { ClaimV1Api } from './claimV1Api';
export * from './diagnosisV3Api';
import { DiagnosisV3Api } from './diagnosisV3Api';
export * from './documentV3Api';
import { DocumentV3Api } from './documentV3Api';
export * from './edgeApi';
import { EdgeApi } from './edgeApi';
export * from './edgeAccountApi';
import { EdgeAccountApi } from './edgeAccountApi';
export * from './edgeAdminApi';
import { EdgeAdminApi } from './edgeAdminApi';
export * from './edgeAuthenticationApi';
import { EdgeAuthenticationApi } from './edgeAuthenticationApi';
export * from './edgeCardApi';
import { EdgeCardApi } from './edgeCardApi';
export * from './edgeClaimApi';
import { EdgeClaimApi } from './edgeClaimApi';
export * from './edgeCmmApi';
import { EdgeCmmApi } from './edgeCmmApi';
export * from './edgeCouponApi';
import { EdgeCouponApi } from './edgeCouponApi';
export * from './edgeDebitCardApi';
import { EdgeDebitCardApi } from './edgeDebitCardApi';
export * from './edgeDigitalPaymentApi';
import { EdgeDigitalPaymentApi } from './edgeDigitalPaymentApi';
export * from './edgeDocumentsApi';
import { EdgeDocumentsApi } from './edgeDocumentsApi';
export * from './edgeEmailApi';
import { EdgeEmailApi } from './edgeEmailApi';
export * from './edgeEmdApi';
import { EdgeEmdApi } from './edgeEmdApi';
export * from './edgeEnrollmentApi';
import { EdgeEnrollmentApi } from './edgeEnrollmentApi';
export * from './edgeHhsApi';
import { EdgeHhsApi } from './edgeHhsApi';
export * from './edgeHubApi';
import { EdgeHubApi } from './edgeHubApi';
export * from './edgeIntakeApi';
import { EdgeIntakeApi } from './edgeIntakeApi';
export * from './edgeMangoApi';
import { EdgeMangoApi } from './edgeMangoApi';
export * from './edgeMedicalApi';
import { EdgeMedicalApi } from './edgeMedicalApi';
export * from './edgePatientAccountApi';
import { EdgePatientAccountApi } from './edgePatientAccountApi';
export * from './edgePatientEnrollmentApi';
import { EdgePatientEnrollmentApi } from './edgePatientEnrollmentApi';
export * from './edgePayloadStagingApi';
import { EdgePayloadStagingApi } from './edgePayloadStagingApi';
export * from './edgePayorApi';
import { EdgePayorApi } from './edgePayorApi';
export * from './edgePharmacyApi';
import { EdgePharmacyApi } from './edgePharmacyApi';
export * from './edgePlpApi';
import { EdgePlpApi } from './edgePlpApi';
export * from './edgePorticoApi';
import { EdgePorticoApi } from './edgePorticoApi';
export * from './edgeProgramApi';
import { EdgeProgramApi } from './edgeProgramApi';
export * from './edgeSignatureApi';
import { EdgeSignatureApi } from './edgeSignatureApi';
export * from './edgeSiteAccountApi';
import { EdgeSiteAccountApi } from './edgeSiteAccountApi';
export * from './edgeTempApi';
import { EdgeTempApi } from './edgeTempApi';
export * from './edgeTenantApi';
import { EdgeTenantApi } from './edgeTenantApi';
export * from './edgeTokenApi';
import { EdgeTokenApi } from './edgeTokenApi';
export * from './emailV1Api';
import { EmailV1Api } from './emailV1Api';
export * from './enrollmentExtV2Api';
import { EnrollmentExtV2Api } from './enrollmentExtV2Api';
export * from './enrollmentV1Api';
import { EnrollmentV1Api } from './enrollmentV1Api';
export * from './escoordV1Api';
import { EscoordV1Api } from './escoordV1Api';
export * from './intakeV1Api';
import { IntakeV1Api } from './intakeV1Api';
export * from './locationV1Api';
import { LocationV1Api } from './locationV1Api';
export * from './notesV2Api';
import { NotesV2Api } from './notesV2Api';
export * from './patientV3Api';
import { PatientV3Api } from './patientV3Api';
export * from './payorV4Api';
import { PayorV4Api } from './payorV4Api';
export * from './payorV4GlobalApi';
import { PayorV4GlobalApi } from './payorV4GlobalApi';
export * from './pharmacyV2Api';
import { PharmacyV2Api } from './pharmacyV2Api';
export * from './pharmacyV2GlobalApi';
import { PharmacyV2GlobalApi } from './pharmacyV2GlobalApi';
export * from './prescriberV3Api';
import { PrescriberV3Api } from './prescriberV3Api';
export * from './prescriptionV1Api';
import { PrescriptionV1Api } from './prescriptionV1Api';
export * from './programV2Api';
import { ProgramV2Api } from './programV2Api';
export * from './siteV2Api';
import { SiteV2Api } from './siteV2Api';
export * from './siteV3Api';
import { SiteV3Api } from './siteV3Api';
export * from './surveyV2Api';
import { SurveyV2Api } from './surveyV2Api';
export * from './surveyV3Api';
import { SurveyV3Api } from './surveyV3Api';

import { Lazy, Scoped } from 'vue-di';
export * from './configure';

@Scoped
export class ApigatewayApi {
    public constructor(
        @Lazy(CardExtV1Api as any) private readonly _cardExtV1: () => CardExtV1Api,
        @Lazy(CaseV3Api as any) private readonly _caseV3: () => CaseV3Api,
        @Lazy(ClaimV1Api as any) private readonly _claimV1: () => ClaimV1Api,
        @Lazy(DiagnosisV3Api as any) private readonly _diagnosisV3: () => DiagnosisV3Api,
        @Lazy(DocumentV3Api as any) private readonly _documentV3: () => DocumentV3Api,
        @Lazy(EdgeApi as any) private readonly _edge: () => EdgeApi,
        @Lazy(EdgeAccountApi as any) private readonly _edgeAccount: () => EdgeAccountApi,
        @Lazy(EdgeAdminApi as any) private readonly _edgeAdmin: () => EdgeAdminApi,
        @Lazy(EdgeAuthenticationApi as any) private readonly _edgeAuthentication: () => EdgeAuthenticationApi,
        @Lazy(EdgeCardApi as any) private readonly _edgeCard: () => EdgeCardApi,
        @Lazy(EdgeClaimApi as any) private readonly _edgeClaim: () => EdgeClaimApi,
        @Lazy(EdgeCmmApi as any) private readonly _edgeCmm: () => EdgeCmmApi,
        @Lazy(EdgeCouponApi as any) private readonly _edgeCoupon: () => EdgeCouponApi,
        @Lazy(EdgeDebitCardApi as any) private readonly _edgeDebitCard: () => EdgeDebitCardApi,
        @Lazy(EdgeDigitalPaymentApi as any) private readonly _edgeDigitalPayment: () => EdgeDigitalPaymentApi,
        @Lazy(EdgeDocumentsApi as any) private readonly _edgeDocuments: () => EdgeDocumentsApi,
        @Lazy(EdgeEmailApi as any) private readonly _edgeEmail: () => EdgeEmailApi,
        @Lazy(EdgeEmdApi as any) private readonly _edgeEmd: () => EdgeEmdApi,
        @Lazy(EdgeEnrollmentApi as any) private readonly _edgeEnrollment: () => EdgeEnrollmentApi,
        @Lazy(EdgeHhsApi as any) private readonly _edgeHhs: () => EdgeHhsApi,
        @Lazy(EdgeHubApi as any) private readonly _edgeHub: () => EdgeHubApi,
        @Lazy(EdgeIntakeApi as any) private readonly _edgeIntake: () => EdgeIntakeApi,
        @Lazy(EdgeMangoApi as any) private readonly _edgeMango: () => EdgeMangoApi,
        @Lazy(EdgeMedicalApi as any) private readonly _edgeMedical: () => EdgeMedicalApi,
        @Lazy(EdgePatientAccountApi as any) private readonly _edgePatientAccount: () => EdgePatientAccountApi,
        @Lazy(EdgePatientEnrollmentApi as any) private readonly _edgePatientEnrollment: () => EdgePatientEnrollmentApi,
        @Lazy(EdgePayloadStagingApi as any) private readonly _edgePayloadStaging: () => EdgePayloadStagingApi,
        @Lazy(EdgePayorApi as any) private readonly _edgePayor: () => EdgePayorApi,
        @Lazy(EdgePharmacyApi as any) private readonly _edgePharmacy: () => EdgePharmacyApi,
        @Lazy(EdgePlpApi as any) private readonly _edgePlp: () => EdgePlpApi,
        @Lazy(EdgePorticoApi as any) private readonly _edgePortico: () => EdgePorticoApi,
        @Lazy(EdgeProgramApi as any) private readonly _edgeProgram: () => EdgeProgramApi,
        @Lazy(EdgeSignatureApi as any) private readonly _edgeSignature: () => EdgeSignatureApi,
        @Lazy(EdgeSiteAccountApi as any) private readonly _edgeSiteAccount: () => EdgeSiteAccountApi,
        @Lazy(EdgeTempApi as any) private readonly _edgeTemp: () => EdgeTempApi,
        @Lazy(EdgeTenantApi as any) private readonly _edgeTenant: () => EdgeTenantApi,
        @Lazy(EdgeTokenApi as any) private readonly _edgeToken: () => EdgeTokenApi,
        @Lazy(EmailV1Api as any) private readonly _emailV1: () => EmailV1Api,
        @Lazy(EnrollmentExtV2Api as any) private readonly _enrollmentExtV2: () => EnrollmentExtV2Api,
        @Lazy(EnrollmentV1Api as any) private readonly _enrollmentV1: () => EnrollmentV1Api,
        @Lazy(EscoordV1Api as any) private readonly _escoordV1: () => EscoordV1Api,
        @Lazy(IntakeV1Api as any) private readonly _intakeV1: () => IntakeV1Api,
        @Lazy(LocationV1Api as any) private readonly _locationV1: () => LocationV1Api,
        @Lazy(NotesV2Api as any) private readonly _notesV2: () => NotesV2Api,
        @Lazy(PatientV3Api as any) private readonly _patientV3: () => PatientV3Api,
        @Lazy(PayorV4Api as any) private readonly _payorV4: () => PayorV4Api,
        @Lazy(PayorV4GlobalApi as any) private readonly _payorV4Global: () => PayorV4GlobalApi,
        @Lazy(PharmacyV2Api as any) private readonly _pharmacyV2: () => PharmacyV2Api,
        @Lazy(PharmacyV2GlobalApi as any) private readonly _pharmacyV2Global: () => PharmacyV2GlobalApi,
        @Lazy(PrescriberV3Api as any) private readonly _prescriberV3: () => PrescriberV3Api,
        @Lazy(PrescriptionV1Api as any) private readonly _prescriptionV1: () => PrescriptionV1Api,
        @Lazy(ProgramV2Api as any) private readonly _programV2: () => ProgramV2Api,
        @Lazy(SiteV2Api as any) private readonly _siteV2: () => SiteV2Api,
        @Lazy(SiteV3Api as any) private readonly _siteV3: () => SiteV3Api,
        @Lazy(SurveyV2Api as any) private readonly _surveyV2: () => SurveyV2Api,
        @Lazy(SurveyV3Api as any) private readonly _surveyV3: () => SurveyV3Api,
    ) {}

    public get cardExtV1() { return this._cardExtV1(); }
    public get caseV3() { return this._caseV3(); }
    public get claimV1() { return this._claimV1(); }
    public get diagnosisV3() { return this._diagnosisV3(); }
    public get documentV3() { return this._documentV3(); }
    public get edge() { return this._edge(); }
    public get edgeAccount() { return this._edgeAccount(); }
    public get edgeAdmin() { return this._edgeAdmin(); }
    public get edgeAuthentication() { return this._edgeAuthentication(); }
    public get edgeCard() { return this._edgeCard(); }
    public get edgeClaim() { return this._edgeClaim(); }
    public get edgeCmm() { return this._edgeCmm(); }
    public get edgeCoupon() { return this._edgeCoupon(); }
    public get edgeDebitCard() { return this._edgeDebitCard(); }
    public get edgeDigitalPayment() { return this._edgeDigitalPayment(); }
    public get edgeDocuments() { return this._edgeDocuments(); }
    public get edgeEmail() { return this._edgeEmail(); }
    public get edgeEmd() { return this._edgeEmd(); }
    public get edgeEnrollment() { return this._edgeEnrollment(); }
    public get edgeHhs() { return this._edgeHhs(); }
    public get edgeHub() { return this._edgeHub(); }
    public get edgeIntake() { return this._edgeIntake(); }
    public get edgeMango() { return this._edgeMango(); }
    public get edgeMedical() { return this._edgeMedical(); }
    public get edgePatientAccount() { return this._edgePatientAccount(); }
    public get edgePatientEnrollment() { return this._edgePatientEnrollment(); }
    public get edgePayloadStaging() { return this._edgePayloadStaging(); }
    public get edgePayor() { return this._edgePayor(); }
    public get edgePharmacy() { return this._edgePharmacy(); }
    public get edgePlp() { return this._edgePlp(); }
    public get edgePortico() { return this._edgePortico(); }
    public get edgeProgram() { return this._edgeProgram(); }
    public get edgeSignature() { return this._edgeSignature(); }
    public get edgeSiteAccount() { return this._edgeSiteAccount(); }
    public get edgeTemp() { return this._edgeTemp(); }
    public get edgeTenant() { return this._edgeTenant(); }
    public get edgeToken() { return this._edgeToken(); }
    public get emailV1() { return this._emailV1(); }
    public get enrollmentExtV2() { return this._enrollmentExtV2(); }
    public get enrollmentV1() { return this._enrollmentV1(); }
    public get escoordV1() { return this._escoordV1(); }
    public get intakeV1() { return this._intakeV1(); }
    public get locationV1() { return this._locationV1(); }
    public get notesV2() { return this._notesV2(); }
    public get patientV3() { return this._patientV3(); }
    public get payorV4() { return this._payorV4(); }
    public get payorV4Global() { return this._payorV4Global(); }
    public get pharmacyV2() { return this._pharmacyV2(); }
    public get pharmacyV2Global() { return this._pharmacyV2Global(); }
    public get prescriberV3() { return this._prescriberV3(); }
    public get prescriptionV1() { return this._prescriptionV1(); }
    public get programV2() { return this._programV2(); }
    public get siteV2() { return this._siteV2(); }
    public get siteV3() { return this._siteV3(); }
    public get surveyV2() { return this._surveyV2(); }
    public get surveyV3() { return this._surveyV3(); }
}

